var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.286,
    height: 33.5,
    viewBox: "0 0 38.286 33.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-gift",
    "data-name": "Icon awesome-gift",
    d: "M2.393,33.357A2.39,2.39,0,0,0,4.786,35.75H16.75V23.786H2.393ZM21.536,35.75H33.5a2.39,2.39,0,0,0,2.393-2.393V23.786H21.536ZM35.893,11.821H32.745A6.52,6.52,0,0,0,33.5,8.83a6.59,6.59,0,0,0-6.58-6.58c-3.111,0-5.122,1.593-7.7,5.107-2.58-3.515-4.591-5.107-7.7-5.107a6.59,6.59,0,0,0-6.58,6.58,6.428,6.428,0,0,0,.755,2.991h-3.3A2.39,2.39,0,0,0,0,14.214V20.2a1.2,1.2,0,0,0,1.2,1.2H37.089a1.2,1.2,0,0,0,1.2-1.2V14.214A2.39,2.39,0,0,0,35.893,11.821Zm-24.385,0a2.991,2.991,0,0,1,0-5.982c1.488,0,2.587.247,6.438,5.982H11.508Zm15.411,0H20.481c3.844-5.72,4.913-5.982,6.438-5.982a2.991,2.991,0,1,1,0,5.982Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftWhite);
export default __webpack_public_path__ + "static/media/gift_white.9e5afaffa9466f9bfec524f544e9748f.svg";
export { ForwardRef as ReactComponent };